import { FC, useState } from 'react'
import { useTranslation } from 'next-i18next'
import { WishlistForm } from './WishlistForm'
import { Button } from '@corratech/pylot-ui'
import { MutationUpdateWishlistArgs, Wishlist } from '@pylot-data/pylotschema'
import { useUpdateWishlist } from '../Hooks/use-update-wishlist'
import { WishlistVisibilityEnum } from '@pylot-data/enums/WishlistVisibilityEnum.d'
import { ToastType, useUI } from '@corratech/pylot-ui/context'
import { useStoreConfig } from '@config/hooks/useStoreConfig'
import s from '@pagestyles/Wishlist.module.scss'

export type Props = {
    wishlist: Wishlist
}

export const UpdateWishlist: FC<Props> = ({ wishlist }) => {
    const { t } = useTranslation(['wishlist'])
    const [isVisible, setIsVisible] = useState(false)
    const { openToast } = useUI()
    const { updateWishlist, isLoading } = useUpdateWishlist()
    const config = useStoreConfig()

    const closeConfirm = () => setIsVisible(false)
    const openConfirm = () => setIsVisible(true)

    const onSubmit = async (inputData: MutationUpdateWishlistArgs) => {
        try {
            const response = await updateWishlist({
                ...inputData,
                wishlistId: wishlist!.id!,
                visibility: inputData?.visibility
                    ? WishlistVisibilityEnum.Public
                    : WishlistVisibilityEnum.Private
            })

            if (response?.errors?.length) {
                openToast(response?.errors[0].message, ToastType.Danger)
            }

            if (response?.data?.updateWishlist) {
                const { name } = response?.data?.updateWishlist

                openToast(
                    t('wishlist|Wish list "{{ name }}" was Updated.', { name }),
                    ToastType.Success
                )
            }
        } catch (e) {
            if (e) {
                openToast(
                    t('wishlist|Something went wrong. Please try again'),
                    ToastType.Danger
                )
            }
        }
        //close confirm box
        closeConfirm()
    }

    if (!config.base.wishlist.multiple_wishlists) return null

    return (
        <>
            <Button
                className={s['edit-link']}
                type="button"
                variant="link"
                onClick={openConfirm}
            >
                {t('wishlist|Edit')}
            </Button>
            <WishlistForm
                onSubmit={onSubmit}
                isLoading={isLoading}
                show={isVisible}
                setShow={setIsVisible}
                wishlist={wishlist}
            />
        </>
    )
}
